import axios from 'axios'

const baseURL = axios.create({baseURL: 'https://www.adamsuperfoods.com'})

export default baseURL